import styled, { css } from 'styled-components';
import { Flexbox } from '@ibinder/common-frontend';

export const LinkLeft = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const LinkRight = styled.div``;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TableContainer = styled.div`
  margin-right: -1rem;
  margin-left: -1rem;
  width: calc(100% + 2rem);
  overflow-x: auto;
  overflow-y: visible;
  height: 100%;
  align-self: stretch;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  ${({ hasSelectBox }) =>
    hasSelectBox &&
    css`
      * > tr > th:nth-child(1),
      * > tr > td:nth-child(1) {
        background: ${({ theme }) => theme.colors.accent};
        position: sticky;
        left: 0px;
        max-width: 3rem;
        min-width: unset;
        z-index: 1;

        > span {
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    `}

  * > tr > th:nth-child(${(p) => (p.hasSelectBox ? 2 : 1)}),
  * > tr > td:nth-child(${(p) => (p.hasSelectBox ? 2 : 1)}) {
    width: ${(p) => (p.truncateFirstColumn ? '15vw' : 'max-content')};
    min-width: ${(p) => (p.truncateFirstColumn ? 'unset' : 'max-content')};
    overflow: ${(p) => (p.truncateFirstColumn ? 'hidden' : 'visible')};
    text-overflow: ${(p) => (p.truncateFirstColumn ? 'ellipsis' : 'clip')};
    white-space: nowrap;
    color: ${(p) => p.theme.colors.primary};

    div {
      position: sticky;
      left: 0px;
    }
  }

  * > tr > th,
  * > tr > td {
    white-space: nowrap;
    background: white;
  }
  th {
    font-weight: ${(p) => p.theme.fontStyles.mediumBoldFont.fontWeight};
  }

  ${({ hasRowAction }) =>
    hasRowAction &&
    css`
      * > tr {
        cursor: pointer;
      }
      * > tr:hover {
        > td {
          background: ${(p) => p.theme.colors.primary10};
        }
      }
      * > tr:active {
        > td {
          background: ${(p) => p.theme.colors.primary20};
        }
      }
    `}
`;

export const TableHead = styled.thead`
  border-bottom: ${(p) => p.theme.colors.primary30};
  tr {
    height: 3rem;
  }
`;
export const TableData = styled.td`
  z-index: ${({ zIndex }) => zIndex};
  border-bottom: 0.0625rem solid ${(p) => p.theme.colors.primary30};
  border-right: ${(p) =>
    p.isFirst ? `0.0625rem solid ${p.theme.colors.primary30}` : 'none'};
  padding: 0;

  button {
    margin: -0.625rem 0 -0.625rem 0;
  }
  padding-left: ${(p) => (p.isSelection ? '0' : '0.75rem')};
  text-align: ${(p) => (p.isSelection ? 'center' : 'left')};
  width: ${(p) => (p.isSelection ? '3rem' : 'unset')};
  font-weight: ${(p) => (p.isGroupHeader ? 'bold' : 'unset')};
  font-size: ${(p) => (p.isGroupHeader ? '1.2' : '1')}rem;
  color: ${(p) =>
    p.isGroupHeader ? p.theme.colors.primary : p.theme.colors.discrete};
  opacity: ${(p) => (p.isExpanded ? '0.4' : '1')};
`;
export const LinkGoToPdf = styled.a`
  min-width: fit-content;
  align-items: center;

  display: flex;
  color: ${(p) => p.theme.colors.primary};
`;
export const ButtonToDownloadPdf = styled.span`
  align-items: center;
  display: flex;
  color: ${(p) => p.theme.colors.primary};
  cursor: pointer;
`;
export const TableHeadItem = styled.th`
  border-right: 0.0625rem solid
    ${(p) => (p.isFirst ? p.theme.colors.primary30 : 'none')};
  border-bottom: 0.0625rem solid ${(p) => p.theme.colors.primary30};
  font-size: 1rem;
  font-weight: 900;
  max-height: 3rem;
  padding-left: ${(p) => (p.isSelection ? '0' : '0.75rem')};
  width: ${(p) => (p.isSelection ? '3rem' : 'unset')};
  color: ${(p) => p.theme.colors.primary};
`;
export const TableHeadContent = styled(Flexbox)`
  justify-content: ${(p) => (p.isSelection ? 'center' : 'space-between')};
`;
export const IconWrapper = styled.div`
  padding-right: 0.5rem;
  font-size: ${(p) => p.theme.fontStyles.smallFont.fontSize}px;
`;

export const TableRow = styled.tr`
  height: 3rem;
`;

export const SortContainer = styled.div`
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

export const HiddenSVGPlaceHolder = styled.svg`
  visibility: hidden;
  height: 3rem;
  width: 3rem;
`;

export const GroupByHeader = styled.span`
  font-weight: ${({ theme }) => theme.fontStyles.smallBoldFont.fontWeight};
`;
